<template>
    <div>
  
  
      <v-toolbar v-if="deleteDialog != true">
  
        <v-btn v-if="orderStepper != 1" icon @click="backPrevious">
          <!-- class="hidden-xs-only" -->
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
  
        <v-toolbar-title v-if="deleteDialog != true">{{ titles[orderStepper] }}</v-toolbar-title>
  
        <v-btn v-if="orderStepper == 1" style="margin-left: auto;" icon @click="submitSearch">
          <!-- class="hidden-xs-only" -->
          <v-icon>mdi-arrow-right-top-bold</v-icon>
        </v-btn>
  
  
        <!-- <v-btn v-if="orderStepper == 3" style="margin-left: auto;" icon @click="preSubmitEdit">
       
          <v-icon>mdi-content-save</v-icon>
        </v-btn> -->
  
        <v-btn v-if="orderStepper == 4 && (!calculated)" style="margin-left: auto;" icon @click="submitEdit">
          <!-- class="hidden-xs-only" -->
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
  
  
        <v-btn v-if="orderStepper == 5" style="margin-left: auto;" icon @click="submitSalesEdit">
          <!-- class="hidden-xs-only" -->
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
  
      </v-toolbar>
  
  
  
  
      <div v-if="orderStepper == 1 && deleteDialog != true">
        <v-card class="mt-5 mb-8">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
  
                  <v-menu ref="fromMenu" v-model="fromMenu" :close-on-content-click="false" transition="scale-transition"
                    offset-y max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fromDate" label="From Date" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="fromDate" type="date" no-title>
                    </v-date-picker>
  
  
                  </v-menu>
  
  
  
                  <v-menu ref="toMenu" v-model="toMenu" :close-on-content-click="false" transition="scale-transition"
                    offset-y max-width="290px" min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="toDate" label="To Date" prepend-icon="mdi-calendar" readonly v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="toDate" type="date" no-title>
                    </v-date-picker>
                  </v-menu>
  
                  <v-text-field v-model="searchKeyWord" label="Name or MobileNo"
                    prepend-inner-icon="mdi-magnify"></v-text-field>
  
  
                  <!-- <v-checkbox v-model="calculatedCheckBox" label="Calculated"></v-checkbox> -->
                </v-col>
  
  
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
      <div v-else-if="orderStepper == 2 && deleteDialog != true">
  
  
  
  
        <swipe-list ref="swipeList" class="card" :disabled="!enabled" :items="content.items" item-key="id"
          :revealed.sync="revealed" :item-disabled="({ disabled }) => disabled" @closed="setLastEvent('closed', $event)"
          @leftRevealed="setLastEvent('leftRevealed', $event)" @rightRevealed="setLastEvent('rightRevealed', $event)"
          
          :disable-right-swipe="true"
          >
          <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
 
            <div ref="content" class="card-content" @click="edit(item)"> 
 
              <v-list-item>
                <v-list-item-avatar>
                  <!-- class="grey lighten-1 white--text" -->
                  <v-img :src="avatarGetLink(item.userRecord.avatar)" shape="circle" />
                  <!-- <v-icon
  
        v-text="`mdi-account`"
      ></v-icon> -->
                </v-list-item-avatar>
                <v-list-item-content>
                  <!-- class="font-weight-bolder" -->
  
                  <v-list-item-subtitle style="font-weight: 100" v-text="item.orderNo"></v-list-item-subtitle>
                  <v-list-item-title class="font-weight-black" v-text="item.userRecord.fullName"></v-list-item-title>
                  <v-list-item-title v-text="item.course.courseName"></v-list-item-title>
                  <v-list-item-subtitle v-text="`Total : $${item.totalAmount}`"></v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-text="`Session : ${item.sessionTotal - item.bookedCourse.length}/${item.sessionTotal}`"></v-list-item-subtitle>
                  <v-list-item-subtitle v-text="`Expriy Date : ${formatDate(item.expiryDate)}`"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </div>
          </template>
   
          <template v-slot:empty>
            <div>
              <!-- change mockSwipeList to an empty array to see this slot in action  -->
              list is empty ( filtered or just empty )
            </div>
          </template>
        </swipe-list>
  
      </div>
      <div v-else-if="orderStepper == 3 && deleteDialog != true">
        <!-- #Order Detail -->
        <v-card class="mt-5 mb-8">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                    <v-card-text class="pl-2" tile>
                      <b>Center </b>
                    </v-card-text>
                  </v-col>
                  <v-col cols="6">
                    <v-card-text class="pl-2" tile>
                      {{ reviewData.center.code}}
                    </v-card-text>
                  </v-col>
    

                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Order No </b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.orderNo }}
                  </v-card-text>
                </v-col>
  
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Membership No </b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.userRecord.userNo }}
                  </v-card-text>
                </v-col>
  
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Membership Name </b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.userRecord.fullName }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Gender </b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.userRecord.gender }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>HKID</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.userRecord.hkid }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Telephone</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.userRecord.mobileNo }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Email</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.userRecord.email }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Promotion</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.promotionID ? reviewData.promotion.fullName : 'none' }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Course</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.course.courseName }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Program</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.sessionTotal  - reviewData.bookedCourse.length }}/{{ reviewData.sessionTotal }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Total Amount</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.totalAmount }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Effective Date</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
  
  
                    {{ reviewData.effectiveDate ?
                      formatDate(reviewData.effectiveDate) : ''
                    }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    <b>Expiry Date</b>
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-text class="pl-2" tile>
                    {{ reviewData.expiryDate ?
                      formatDate(reviewData.expiryDate) : ''
                    }}
                  </v-card-text>
                </v-col>
  
                <v-col cols="12">
  
                  <!-- <v-btn color="#3467eb" left plain @click="submitCommissionPage">
                    <u>Salesman & Commission Precentage</u>
                  </v-btn> -->
                  <v-btn color="#3467eb" left plain  @click="submitConditionPage">
                    <!-- @click="submitConditionPage" -->
                    <u>Terms & Condition</u>
                  </v-btn>
                </v-col>
  
  
  
              </v-row>
  
     
  
            </v-container>
          </v-card-text>
        </v-card>
  
      </div>
      <div v-else-if="orderStepper == 4 && deleteDialog != true">
  
        <v-card-title style="word-break: break-word" v-if="calculated">
  
          <span v-if="calculated" class="warning-commission">
            <br>
            This section cant't change since commission has already calculated
          </span>
  
  
        </v-card-title>
  
        <swipe-list ref="swipecoachList" class="card" :disabled="!enabled" :items="coachCommissionList.items" item-key="id"
          :revealed.sync="revealed" :item-disabled="({ disabled }) => disabled" :disable-right-swipe="true">
          <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
      
  
            <v-row no-gutters>
              <v-col cols="9">
                <v-list-item>
                  <v-list-item-avatar>
                    <!-- class="grey lighten-1 white--text" -->
                    <v-img :src="avatarGetLink(item.userRecord.avatar)" shape="circle" />
                    <!-- <v-icon
  
        v-text="`mdi-account`"
      ></v-icon> -->
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <!-- class="font-weight-bolder" -->
  
                    <v-list-item-subtitle style="font-weight: 100" v-text="item.orderNo"></v-list-item-subtitle>
                    <v-list-item-title class="font-weight-black" v-text="item.userRecord.fullName"></v-list-item-title>
                    <v-list-item-title>
                      <v-slider :disabled="calculated" v-model="coachCommissionList.items[index].commissionPercentage"
                        step="1" ticks>
                      </v-slider>
                      {{ coachCommissionList.items[index].commissionPercentage }}%
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col cols="3">
  
                <v-btn :disabled="calculated" tile style="height: 100%; " color="#ff0000"
                  @click="submitDeleteSalesman(item)">
                  <v-icon large color="white">
                    mdi-trash-can
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </template>
  
          <!-- <template v-slot:right="{ item }">
  
        <div class="swipeout-action red"   @click="submitDelete(item)">
  
          <v-icon large color="white">mdi-trash-can</v-icon>
  
        </div>
      </template>   -->
          <template v-slot:empty>
            <div>
              <!-- change mockSwipeList to an empty array to see this slot in action  -->
              list is empty ( filtered or just empty )
            </div>
          </template>
        </swipe-list>
  
        <v-snackbar v-model="snackbar" centered timeout="2000">
          Total percentage is more than 100%
        </v-snackbar>
  
  
      </div>
      <div v-else-if="orderStepper == 5">
        <v-row style="padding-top: 12px;">
          <v-col cols="12">
            <div class="pl-2">
              <span class="text-h9 wrap"><b>Select one or more sales and then click save icon</b><br></span>
            </div>
          </v-col>
  
          <v-col cols="12">
            <user-list ref="selectTempSalesList" 
            enableSearch = "true"
            :user-list="tempSalesList" limit="3" @click="handleSalesClick"
              @remove="handleSalesRemove"></user-list>
          </v-col>
        </v-row>
      </div>
  
      <div v-else-if="orderStepper == 6">
        <v-container class="card-container">

 
          <v-card class="scroll" style="width: 100%;">
            <v-card-text>
              <RichEditor 
              :currentData="termsConditionItemData" 
              disableButton>
              </RichEditor>
      
            </v-card-text>
      
          </v-card>
      
      
        </v-container>
      </div>
  
  
      <div class="text-center">
        <v-dialog v-model="editDialog" persistent max-width="290">
  
          <v-card>
            <v-card-title style="word-break: break-word">
              <span class="text-h5 wrap"><b>Transfer order from {{ oldCenter }} to {{ newCenter }}?</b><br></span>
  
              <span class="wrap editH1Dialog">
                <br>
                All existing incomplete course booking would be cancel if invalid for {{ newCenter }}
              </span>
  
  
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="dark" text @click="editDialog = false">
                Back
              </v-btn>
              <!-- color="green darken-1" -->
              <v-btn :loading="loading" color="blue" text @click="confirmSubmitEdit">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
  
      <div class="text-center">
        <v-dialog v-model="deleteDialog" width="600px">
  
          <v-card>
            <v-card-title style="word-break: break-word">
              <span class="text-h5"><b>Void Order {{ reviewData.orderNo }}</b></span>
            </v-card-title>
            <v-card-text>
              <v-col cols="12">
                <v-text-field label="Reason" v-model="voidReason"></v-text-field>
              </v-col>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="dark" text @click="deleteDialog = false">
                Back
              </v-btn>
              <!-- color="green darken-1" -->
              <v-btn :loading="loading" color="dark" text @click="confirmSubmitDelete">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
  
      <v-btn v-if="orderStepper == 2" color="#4fdea4" absolute bottom right fab @click="goToCreateOrder">
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
  
  
  
      <v-btn v-if="orderStepper == 4" color="#4fdea4" absolute bottom right fab @click="findOrderSales">
        <v-icon color="white">
          mdi-plus
        </v-icon>
      </v-btn>
  
  
  
      <v-overlay :z-index="999" :value="progressLoading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
  
  
      <div class="text-center">
        <v-dialog v-model="deleteSalesmanDialog" width="600px">
          <v-card v-if="tempItem != null">
            <v-card-title>
              <span class="wrap editH1Dialog"><b>Are you sure to delete
                  {{ tempItem.userRecord.fullName }} in Order No: {{ reviewData.orderNo }}</b></span>
            </v-card-title>
  
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="dark" text @click="cancelDeleteSalesman">
                Back
              </v-btn>
  
              <v-btn :loading="loading" color="dark" text @click="confirmSubmitDeleteSalesman">
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>


    </div>
  </template>
  
  <script>
  import { createItem, deleteItem,  getItem, updateItem, commissionFetchList , fetchHistoryListForCoach as fetchList } from '@/api/salesOrder'
  import { fetchList as centerFetchList } from '@/api/center'
  // import css from '../../src/styles/vue-swipe-actions.css';
  import {
    createItem as orderSalesmanCreateItem, deleteItem as commissionDeleteItem,
    updateItem as commissionUpdateItem, fetchList as orderSalesmanFetchList
  } from '@/api/orderSalesman'
  
  import CRUDTable from '@/components/CRUD/CRUDTable'
  import { useStore } from '@/store'
  import {
    mdiAccountOutline,
    mdiDeleteOutline,
    mdiDotsVertical,
    mdiExportVariant,
    mdiFileDocumentOutline,
    mdiPlus,
    mdiSquareEditOutline,
  } from '@mdi/js'
  
  import { ref } from 'vue'
  import * as moment from 'moment';
  import UniversalInput from '@/components/CRUD/UniversalInput.vue'
  import SwipeList from '@/components/SwipeList/SwipeList.vue'
  import UserList from '@/components/UserSelector/UserList'
  import '@/styles/swipelist.css'
  import RichEditor from '@/components/RichEditor/RichEditor.vue'
  import {  getItem as getTermsConditionItem} from '@/api/termsCondition'


import router from '@/router'
  export default {
    components: {
      CRUDTable,
      SwipeList,
      UniversalInput,
      UserList,
      RichEditor
    },
    name: 'OrderHistory',
    mounted() {
      // ideally should be in some global handler/store
      window.addEventListener('keydown', this.onKeyDown);
      window.addEventListener('keyup', this.onKeyUp);
    },
    beforeDestroy() {
      window.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('keyup', this.onKeyUp);
    },
    data() {
      return {
        enabled: true,
        page: 0,
        revealed: {},
        lastEventDescription: '',
        mockSwipeList: [
          [
            {
              id: 'a',
              title: 'Some title',
              description: 'some description',
              disabled: true,
            },
            {
              id: 'b',
              title: 'Some title',
              description: 'some description',
              disabled: false,
            },
            {
              id: 'c',
              title: 'Some title',
              description: 'some description',
              disabled: false,
            },
          ],
          [
            {
              id: 'd',
              title: 'Some title',
              description: 'some description',
              disabled: false,
            },
            {
              id: 'e',
              title: 'Some title',
              description: 'some description',
              disabled: false,
            },
            {
              id: 'f',
              title: 'Some title',
              description: 'some description',
              disabled: false,
            },
          ],
        ],
        titles: {
          1: 'Order History Search',
          2: 'Order List',
          3: 'Order Detail',
          4: 'Order Commission',
          5: 'Assign Salesman',
          6: 'Terms Conditions',
       
        },
        orderStepper: 1,
        fromDate: moment(Date.now()).clone().add('days', -180).format('YYYY-MM-DD'),
        fromMenu: false,
        toDate: moment(Date.now()).format('YYYY-MM-DD'),
        toMenu: false,
        searchKeyWord: '',
        progress: false,
        content: [],
        reviewData: [],
        testitems: [
          { title: 'Click Me' },
          { title: 'Click Me' },
          { title: 'Click Me' },
          { title: 'Click Me 2' },
        ],
        centerItems: [],
        tempCenterCode: '',
  
  
  
  
  
        inputCenterConfig:
        {
          propName: 'tempCenterCode',
          // label: 'Code',
          // defaultValue: 5,
          type: {
            name: 'select',
            items: [],
            itemText: 'code',
            itemValue: 'id',
          },
        },
        deleteDialog: false,
  
        deleteSalesmanDialog: false,
  
        voidReason: '',
        editDialog: false,
        oldCenter: '',
        newCenter: '',
  
        snackbar: false,
  
        coachCommissionList: [],
  
        tempSalesList: [],
        tempCoachList: [],
  
        selectedSales: [],
        selectedCoach: [],
  
        calculated: false,
        orderID: 0,
  
        calculatedCheckBox: false,
        tempItem : null,

        termsConditionItemData : '',
      }
    },
    // mounted(){
    //   // this.$set(this.inputCenteConfig.type, 'items', this.centerItems)
  
    // },
    methods: {
  

      scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
},
      avatarGetLink(avatar){
        if (avatar == undefined){
          return ''
        }
    return process.env.VUE_APP_BASE_API +  avatar
    },

    submitConditionPage() {
    
    this.progressLoading = true
 
    getTermsConditionItem(this.reviewData.termsID)
     .then(response => {
       this.termsConditionItemData   =   response.data.record.content
       this.orderStepper = 6
       this.scrollToTop()
       this.progressLoading = false
     })
     .catch(err => {  
       this.progressLoading = false
      })
 
 
 },
 




      //#region PageControl
      backPrevious() {
  
        if (this.orderStepper == 6) {
          this.orderStepper = 3
          this.scrollToTop()
          return
        }

        if (this.orderStepper > 1) {
          this.orderStepper -= 1
        }
        if (this.orderStepper == 1) {
          this.content = []
        }
      },
  
      submitSearchWithoutChangeOrderStepper() {
        this.progressLoading = true
        //  loading.value = true
        fetchList({ page: 0, limit: 0, Todate: this.toDate, FromDate: this.fromDate, searchKeyWord: this.searchKeyWord })
          .then(response => {
            this.progressLoading = false
            console.log('Order History response', response)
            this.content = response.data
            console.log('content value', this.content)
            // loading = false
          })
          .catch(err => {
            this.progressLoading = true
            // loading = false
          })
  
  
  
      },
  
      //#endregion
  
      //#region orderstepper1
      submitSearch() {
        this.orderStepper = 2
        this.progressLoading = true
        //  loading.value = true
        fetchList({
          page: 0, limit: 0, Todate: this.toDate, FromDate: this.fromDate, searchKeyWord: this.searchKeyWord,
          Calculated: this.calculatedCheckBox
        })
          .then(response => {
            this.progressLoading = false
            console.log('Order History response', response)
            this.content = response.data
            console.log('content value', this.content)
            // loading = false
          })
          .catch(err => {
            this.progressLoading = false
            // loading = false
          })
  
  
  
      },
      //#endregion
  
      //#region orderstepper2
      edit(item) {
        console.log("edit", item)
        this.reviewData = item
        this.orderStepper = 3
        this.scrollToTop()
        this.orderID = item.id
  
        this.calculated = item.calculated
  
        centerFetchList({ page: 0, limit: 0 })
          .then(response => {
            console.log('center  response', response)
            this.centerItems = response.data.items
            this.inputCenterConfig.type.items.push(...this.centerItems)
            // console.log('inputCenterConfig',this.inputCenterConfig.filter(object => object == this.reviewData.centerID))
            // this.tempCenterCode = this.inputCenterConfig.filter(object => object == this.reviewData.centerID)
          })
          .catch(err => {
            // loading = false
          })
  
  
      },
  
      goToCreateOrder()
      {
       
        this.$router.push({ name: 'COACH_Create_Order'  })
      },


      //#endregion
  
  
  
      //#region orderstepper3
      preSubmitEdit(item) {
        const oldObject = this.centerItems.find(object => object.id === this.reviewData.centerID);
        const newObject = this.centerItems.find(object => object.id === this.tempCenterCode);
        this.oldCenter = oldObject.code
        this.newCenter = newObject.code
  
  
        //  this.oldCenter 
        //  this.oldCenter 
        if (this.reviewData.centerID != this.tempCenterCode) {
          this.editDialog = true
        }
  
  
      },
  
      confirmSubmitEdit() {
        this.loading = true
        this.progressLoading = true
        this.reviewData.FromCenterID = this.reviewData.centerID
        this.reviewData.ToCenterID = this.tempCenterCode
        // this.editDialog = false
        // this.loading   = false
        this.reviewData.CenterID = this.tempCenterCode
        updateItem(this.reviewData)
          .then(response => {
            this.progressLoading = false
            this.editDialog = false
            this.loading = false
            this.submitSearchWithoutChangeOrderStepper()
            this.reviewData.FromCenterID = null
            this.tempCenterCode.ToCenterID = null
          })
          .catch(err => {
            this.progressLoading = false
            this.loading = false
            this.editDialog = false
  
          })
  
      },
  
  
      submitCommissionPage() {
        this.orderStepper = 4
        this.scrollToTop()
        this.fetchCoachdata()
  
  
        getItem(this.orderID).then(response => {
  
          this.calculated = response.data.record.calculated
        }).catch(err => {
        })
  
  
  
  
        console.log('submitCommissionPage')
      },
  
  
      //#endregion
  
      //#region orderstepper4
      fetchCoachdata() {
        this.progressLoading = true
  
        // this.coachCommissionList = []
        commissionFetchList({ page: 0, limit: 0, orderNo: this.reviewData.orderNo })
          .then(response => {
            this.progressLoading = false
            console.log('commissionFetchList', response)
            this.coachCommissionList = response.data
          })
          .catch(err => {
            this.progressLoading = false
  
            // loading = false
          })
      },
  
      submitEdit() {
        if (this.calculated == false) {
          let percentageValue = 0
          console.log('aaa', this.coachCommissionList.items.length)
          for (let i = 0; i < this.coachCommissionList.items.length; i++) {
            console.log('this.coachCommissionList[i].CommissionPercentage', this.coachCommissionList.items[i].commissionPercentage)
            percentageValue += this.coachCommissionList.items[i].commissionPercentage
          }
  
          console.log('percentageValue', percentageValue)
  
          if (percentageValue <= 100) {
            this.progressLoading = true
            console.log('this.coachCommissionList', this.coachCommissionList)
  
  
            // this.progressLoading = true
            commissionUpdateItem(this.coachCommissionList).then(response => {
  
  
              this.fetchCoachdata()
  
              getItem(this.orderID).then(response => {
  
                this.calculated = response.data.record.calculated
              }).catch(err => {
              })
  
            })
              .catch(err => {
  
              })
          } else {
            this.snackbar = true
          }
        }
  
      },
  
  
      submitDeleteSalesman(item) {
        console.log('submit salesman Delete', item)
        // this.tempItem = item
        // this.deleteSalesmanDialog = true
  
  
      },
  
      confirmSubmitDeleteSalesman() {
  
        this.progressLoading = true
  
  
        commissionDeleteItem(this.tempItem)
          .then(response => {
            this.deleteSalesmanDialog = false
            this.progressLoading = false
  
            this.fetchSalesData()
          })
          .catch(err => {
            this.deleteSalesmanDialog = false
            this.progressLoading = false
          })
  
      },
  
  
      //#endregion
  
      // #region orderstepper5
      findOrderSales() {
        console.log('findOrderSales')
        this.orderStepper = 5
        this.scrollToTop()
        this.fetchSalesData()
  
        // this.progressLoading = true
      },
  
      fetchSalesData() {
        this.progressLoading = true
        orderSalesmanFetchList({ page: 0, limit: 0, SalesOrderID: this.reviewData.id })
          .then(response => {
            this.progressLoading = false
            this.tempSalesList = response.data.items
          })
          .catch(err => {
            this.progressLoading = false
          })
      },
  
      handleSalesClick(item) {
        if (item) {
          console.log('handleSalesClick', item)
          this.selectedSales.push(item)
  
          // this.selectedSales.push(...Object.values(item))
          // this.selectedSales  = [...item.salesOrders]
  
          // console.log('handleSalesClick added' , this.selectedSales )
        }
      },
  
      handleSalesRemove(item) {
        console.log('handleRemove', item)
        this.selectedSales.push(item)
      },
  
      submitSalesEdit() {
        console.log('submitSalesEdit', this.selectedSales)
        this.progressLoading = true
        orderSalesmanCreateItem({ SalesOrderID: this.reviewData.id, UserRecord: this.selectedSales })
          .then(response => {
            this.fetchSalesData()
            this.fetchCoachdata()
            this.progressLoading = false
            this.orderStepper = 4
            this.scrollToTop()
  
          })
          .catch(err => {
            this.progressLoading = false
            this.orderStepper = 4
            this.scrollToTop()
          })
      },
  
      // #endregion
  
  
      submitDelete(item) {
        console.log('submitDeletessssssssssssss', item)
        this.deleteDialog = true
  
        this.reviewData = item
      },
  
      confirmSubmitDelete() {
        this.loading = true
        this.progressLoading = true
        this.reviewData.voidReason = this.voidReason
  
  
        deleteItem(this.reviewData)
          .then(response => {
            this.progressLoading = false
            this.deleteDialog = false
            this.voidReason = ''
            this.loading = false
            this.submitSearch()
          })
          .catch(err => {
            this.progressLoading = false
            this.deleteDialog = false
            this.voidReason = ''
            this.loading = false
          })
  
      },
  
    
  
  
  
      //region commmonService
      setLastEvent(name, { item, index }) {
        this.lastEventDescription = {
          name,
          index,
          id: item.id,
        };
  
  
      },
  
  
      // keyboard
      onKeyDown(e) {
        if (e.keyCode !== 16) return;
        this.enabled = false;
      },
      onKeyUp(e) {
        if (e.keyCode !== 16) return;
        this.enabled = true;
      },
  
  
  
      formatDate(date) {
        var d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();
  
        if (month.length < 2)
          month = '0' + month;
        if (day.length < 2)
          day = '0' + day;
  
        return [year, month, day].join('-');
      },
  
      //#endregion
  
  
    },
    setup() {
  
      const loading = ref(false)
      const progressLoading = ref(false)
  
  
      return {
        loading,
        progressLoading,
      }
    },
  }
  </script>
  
  <style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>
  
  <style>
  /* @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"); */
  
  .swipeout-padding {
    margin-left: -2%;
  }
  
  .centered {
    position: fixed;
    /* or absolute */
    top: 50%;
    left: 50%;
  }
  
  .editH1Dialog {
    color: red !important;
    font-size: 18px;
    width: 100%;
    /*Dont really required*/
  
    text-align: center;
    word-wrap: break-word;
  }
  
  .warning-commission {
  
    color: red !important;
    font-size: 12px;
    text-align: left;
    word-wrap: break-word;
  
  }
  
  
  .wrap {
    width: 100%;
    /*Dont really required*/
    text-align: center;
    word-wrap: break-word;
  }
  
  /* app specific styles */
  .vcenter {
    display: flex;
    align-items: center;
    height: 56px;
  }
  
  .swipeout-action {
    display: flex;
    align-items: center;
    padding: 0 3rem;
    cursor: pointer;
    left: 0;
  
  }
  
  /* https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/color/ */
  .swipeout-action.blue {
    color: white;
    background-color: rgb(0, 122, 255);
  }
  
  .swipeout-action.blue:hover {
    background-color: darken(rgb(0, 122, 255), 5%);
  }
  
  .swipeout-action.purple {
    color: white;
    background-color: rgb(88, 86, 214);
  }
  
  .swipeout-action.purple:hover {
    background-color: darken(rgb(88, 86, 214), 5%);
  }
  
  .swipeout-action.red {
    color: white;
    background-color: rgb(255, 59, 48);
  }
  
  .swipeout-action.red:hover {
    background-color: darken(rgb(255, 59, 48), 5%);
  }
  
  .swipeout-action.green {
    color: white;
    background-color: rgb(76, 217, 100);
  }
  
  .swipeout-action.green:hover {
    background-color: darken(rgb(76, 217, 100), 5%);
  }
  
  
  .swipeout-list-item {
    flex: 1;
    border-bottom: 1px solid lightgray;
  }
  
  .swipeout-list-item:last-of-type {
    border-bottom: none;
  }
  
  .card {
    width: 100%;
    background-color: white;
    border-radius: 3px;
    box-shadow: none;
    border: 1px solid lightgray;
  }
  
  .card-content {
    padding: 1rem;
  }
  
  .transition-right {
    transform: translate3d(100%, 0, 0) !important;
  }
  
  .transition-left {
    transform: translate3d(-100%, 0, 0) !important;
    /* transform: translate3d(-100%, 0 ,0) !important; */
  }
  
  .toolbar {
    display: flex;
    align-items: center;
  }
  
  .toolbar .toolbar-section {
    flex: 0 0 auto;
  }
  
  .toolbar .toolbar-section--center {
    flex: 1000 1 0%;
  }
  </style>
  